import React from 'react';

// French translations (Français)
export const frenchTranslations = {
  // ========== NAVIGATION & MISE EN PAGE ==========
  title: "Duelity Gaming Tournament Platform",
  welcome: "Bienvenue",
  points: "Points",
  logout: "Déconnexion",
  tournaments: "Tournois",
  pointsProfile: "Points & Profil",
  matchHistory: "Historique des Matchs",
  adminPanel: "Panneau Admin",
  approverPanel: "Panneau Approbateur",
  supervisorPanel: "Panneau Superviseur",
  managerPanel: "Panneau Manager",
  login: "Connexion",
  register: "S'inscrire ici",
  myProfile: "Mon Profil",
  dontHaveAccount: "Pas de compte ?",
  language: "Langue",
  liveChat: "Chat en Direct",
  menu: "Menu",
  publicProfile: "PUBLIC",
  levelsBadges: "Niveau & Progression",

  // ========== AUTHENTIFICATION ==========
  username: "Nom d'utilisateur",
  password: "Mot de passe",
  email: "E-mail",
  inGameName: "Nom en Jeu",
  backToLogin: "Retour à la Connexion",
  createAccount: "Créer un Compte",
  loginSuccessful: "Connexion réussie !",
  welcomeBattlefield: "Bienvenue sur le champ de bataille!",
  registrationSuccessful: "Inscription réussie !",
  logoutSuccessful: "Déconnexion réussie",
  loggingIn: "Connexion en cours...",
  creatingAccount: "Création du compte...",

  // ========== VALIDATION DES CHAMPS ==========
  loginSubtitle: "Connectez-vous à votre compte",
  fillAllFields: "Remplissez tous les champs pour créer votre compte",
  enterUsername: "Entrez votre nom d'utilisateur",
  enterPassword: "Entrez votre mot de passe",
  enterEmail: "Entrez votre adresse e-mail",
  enterInGameName: "Enter your in-game name",
  reenterPassword: "Confirmez votre mot de passe",
  confirmPassword: "Confirmer le mot de passe",

  // Erreurs de validation
  usernameRequired: "Le nom d'utilisateur est requis",
  usernameTooShort: "Le nom d'utilisateur doit contenir au moins 3 caractères",
  usernameTooLong: "Le nom d'utilisateur doit contenir moins de 20 caractères",
  usernameNoHebrew: "Le nom d'utilisateur ne peut pas contenir de caractères hébreux",
  usernameNoArabic: "Le nom d'utilisateur ne peut pas contenir de caractères arabes",
  usernameInvalidChars: "Le nom d'utilisateur ne peut contenir que des lettres, chiffres, underscore et tiret",
  emailRequired: "L'e-mail est requis",
  emailInvalid: "Veuillez entrer une adresse e-mail valide",
  inGameNameRequired: "Le nom en jeu est requis",
  inGameNameTooShort: "Le nom en jeu doit contenir au moins 2 caractères",
  inGameNameTooLong: "Le nom en jeu doit contenir moins de 30 caractères",
  passwordRequired: "Le mot de passe est requis",
  passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
  passwordTooLong: "Le mot de passe doit contenir moins de 50 caractères",
  passwordNeedsNumber: "Le mot de passe doit contenir au moins un chiffre",
  passwordNeedsLetter: "Le mot de passe doit contenir au moins une lettre",
  confirmPasswordRequired: "Veuillez confirmer votre mot de passe",
  passwordsDoNotMatch: "Les mots de passe ne correspondent pas",

  // Validation réussie
  usernameValid: "Le nom d'utilisateur est valide",
  emailValid: "L'e-mail est valide",
  inGameNameValid: "Le nom en jeu est valide",
  passwordValid: "Le mot de passe est valide",
  passwordsMatch: "Les mots de passe correspondent",

  // Exigences du mot de passe
  min6Chars: "Au moins 6 caractères",
  hasLetter: "Contient une lettre",
  hasNumber: "Contient un chiffre",

  // Erreurs de connexion
  invalidCredentials: "Nom d'utilisateur ou mot de passe invalide",
  userNotFound: "Utilisateur non trouvé. Vérifiez votre nom d'utilisateur.",
  wrongPassword: "Mot de passe incorrect. Veuillez réessayer.",
  accountDisabled: "Votre compte a été désactivé. Contactez le support.",
  loginFailed: "Échec de la connexion. Veuillez réessayer.",
  registrationFailed: "Échec de l'inscription. Veuillez réessayer.",


  // ========== PASSWORD RECOVERY ==========
  forgotPassword: "Mot de passe oublié ?",
  forgotPasswordTitle: "Mot de passe oublié",
  forgotPasswordSubtitle: "Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  sendResetLink: "Envoyer le lien",
  sending: "Envoi en cours...",
  checkYourEmail: "Vérifiez votre e-mail",
  resetLinkSent: "Si un compte avec cet e-mail existe, vous recevrez bientôt un lien de réinitialisation. Veuillez également vérifier votre dossier spam.",
  linkExpiresIn: "Le lien expirera dans 1 heure.",
  resetPassword: "Réinitialiser",
  resetPasswordTitle: "Réinitialiser le mot de passe",
  resetPasswordSubtitle: "Entrez votre nouveau mot de passe ci-dessous.",
  newPassword: "Nouveau mot de passe",
  confirmNewPassword: "Confirmer le mot de passe",
  enterNewPassword: "Entrez le nouveau mot de passe",
  confirmNewPasswordPlaceholder: "Confirmez le nouveau mot de passe",
  resetting: "Réinitialisation...",
  passwordResetSuccess: "Mot de passe réinitialisé !",
  passwordResetSuccessMessage: "Votre mot de passe a été réinitialisé avec succès.",
  redirectingToLogin: "Redirection vers la page de connexion...",
  loginNow: "Se connecter",
  invalidResetLink: "Lien invalide",
  invalidResetLinkMessage: "Ce lien de réinitialisation est invalide ou a expiré.",
  resetLinkExpiredNote: "Les liens expirent après 1 heure pour des raisons de sécurité.",
  requestNewResetLink: "Demander un nouveau lien",
  verifyingResetLink: "Vérification du lien...",

// ========== RECUPERATION MOT DE PASSE ==========  forgotPassword: "Mot de passe oublié ?",  forgotPasswordTitle: "Mot de passe oublié",  forgotPasswordSubtitle: "Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",  sendResetLink: "Envoyer le lien",  sending: "Envoi en cours...",  checkYourEmail: "Vérifiez votre e-mail",  resetLinkSent: "Si un compte avec cet e-mail existe, vous recevrez bientôt un lien de réinitialisation. Veuillez également vérifier votre dossier spam.",  linkExpiresIn: "Le lien expirera dans 1 heure.",  resetPassword: "Réinitialiser",  resetPasswordTitle: "Réinitialiser le mot de passe",  resetPasswordSubtitle: "Entrez votre nouveau mot de passe ci-dessous.",  newPassword: "Nouveau mot de passe",  confirmNewPassword: "Confirmer le mot de passe",  enterNewPassword: "Entrez le nouveau mot de passe",  confirmNewPasswordPlaceholder: "Confirmez le nouveau mot de passe",  resetting: "Réinitialisation...",  passwordResetSuccess: "Mot de passe réinitialisé !",  passwordResetSuccessMessage: "Votre mot de passe a été réinitialisé avec succès.",  redirectingToLogin: "Redirection vers la page de connexion...",  loginNow: "Se connecter",  invalidResetLink: "Lien invalide",  invalidResetLinkMessage: "Ce lien de réinitialisation est invalide ou a expiré.",  resetLinkExpiredNote: "Les liens expirent après 1 heure pour des raisons de sécurité.",  requestNewResetLink: "Demander un nouveau lien",  verifyingResetLink: "Vérification du lien...",
  // ========== SYSTÈME DE NIVEAU PRINCIPAL ==========
  level: "Niveau",
  levels: "Niveaux",
  experience: "Expérience",
  exp: "EXP",
  totalExp: "EXP Total",
  expNeeded: "EXP nécessaire",
  expToNext: "EXP pour le prochain niveau",
  expGained: "EXP Gagné",
  expReward: "Récompense EXP",
  currentLevel: "Niveau Actuel",
  nextLevel: "Niveau Suivant",
  maxLevel: "NIVEAU MAX !",
  levelUp: "NIVEAU SUPÉRIEUR !",
  levelProgress: "Progression du Niveau",
  levelSystem: "Système de Niveau",
  loadingLevel: "Chargement du niveau...",
  levelTooltip: "Niveau {level} - {title}\n{totalExp} EXP total\n{remaining}",

  // ========== TITRES DE NIVEAU ==========
  beginner: "Débutant",
  novice: "Novice",
  intermediate: "Intermédiaire",
  advanced: "Avancé",
  professional: "Professionnel",
  expert: "Expert",
  master: "Maître",
  grandmaster: "Grand Maître",
  mythic: "Mythique",
  sage: "Sage",
  legend: "Légende",

  // ========== SYSTÈME DE BADGES ==========
  badges: "Badges",
  badge: "Badge",
  earnedBadges: "Obtenus",
  inProgress: "En Cours",
  allBadges: "Tous",
  loadingBadges: "Chargement des badges...",
  noBadges: "Pas encore de badges",
  badgeUnlocked: "Badge Débloqué !",
  badgeProgress: "Progression du Badge",
  badgeModal: "Détails du Badge",
  comingSoon: "Bientôt Disponible",
  systemLoading: "Chargement du système...",
  noBadgesYet: "Pas encore de badges",
  characterCount: "{count}/1000",
  progressPercentage: "{percentage}% complété",
  currentProgress: "Progression Actuelle",

  // ========== CATÉGORIES DE BADGES ==========
  allCategories: "Toutes les Catégories",
  winStreak: "Série de Victoires",
  filler: "Remplisseur",
  totalWins: "Victoires Totales",
  pointsWinning: "Points Gagnés",
  pointsPurchase: "Achat de Points",
  multiplayer: "Multijoueur",
  battleRoyale: "Battle Royale",
  multiplayerWins: "Victoires Multijoueur",
  battleRoyaleWins: "Victoires Battle Royale",

  // ========== RARETÉ DES BADGES ==========
  common: "Commun",
  rare: "Rare",
  epic: "Épique",
  legendary: "Légendaire",

  // ========== MODAL BADGE ==========
  close: "Fermer",
  category: "Catégorie",
  requirement: "Condition",
  unlocked: "Débloqué",
  unlockedOn: "Débloqué le",
  progress: "Progression",
  remaining: "restant",
  tip: "Conseil",
  gotIt: "Compris !",

  // ========== INDICATEURS DE PROGRESSION ==========
  complete: "Terminé",
  completion: "Complétion",
  showMore: "Voir Plus",
  showLess: "Voir Moins",
  upcoming: "À Venir",
  upcomingMilestones: "Prochaines Étapes",
  congratsMaxLevel: "Félicitations ! Vous avez atteint le niveau maximum !",
  totalExpEarned: "EXP total gagné",
  progressDetails: "Détails de Progression",
  expForCurrentLevel: "EXP pour le niveau actuel",
  expForNextLevel: "EXP pour le prochain niveau",
  progressToNext: "Progression vers le prochain niveau",

  // ========== INDICATEURS DE STATUT ==========
  loading: "Chargement...",
  loadingProgress: "Chargement de la progression...",
  offline: "Hors ligne",
  online: "En ligne",

  // ========== CONSEILS BADGES ==========
  winStreakTip: "Continuez à gagner des parties consécutives pour atteindre cet objectif ! Il vous faut {remaining} victoires de plus d'affilée.",
  totalWinsTip: "Gagnez plus de tournois pour débloquer ce badge. {remaining} victoires restantes !",
  pointsWinningTip: "Gagnez plus de points en remportant des tournois. Il vous faut {remaining} points de plus.",
  pointsPurchaseTip: "Achetez plus de points pour débloquer ce badge. {remaining} points restants à acheter.",
  fillerTip: "Ajoutez des joueurs de remplissage aux tournois et espérez qu'ils gagnent ! {remaining} victoires de remplissage supplémentaires nécessaires.",
  multiplayerTip: "Jouez plus de tournois multijoueur. {remaining} parties restantes.",
  battleRoyaleTip: "Participez à plus de matchs Battle Royale. {remaining} parties restantes.",
  multiplayerWinsTip: "Gagnez plus de tournois multijoueur. {remaining} victoires nécessaires.",
  battleRoyaleWinsTip: "Gagnez plus de matchs Battle Royale. {remaining} victoires pour débloquer.",
  genericTip: "Continuez à jouer pour débloquer ce badge ! {remaining} restants.",

  // ========== NOTIFICATIONS DE NIVEAU ==========
  levelUpNotification: "Niveau Supérieur !",
  levelUpTitle: "Félicitations !",
  levelUpSubtitle: "Vous avez atteint un nouveau niveau !",
  newLevelUnlocked: "Nouveau niveau débloqué",
  titleEarned: "Titre obtenu",

  // ========== STATISTIQUES ==========
  statistics: "Statistiques",
  totalEarned: "Total Gagné",
  totalAvailable: "Total Disponible",
  completionPercentage: "Pourcentage de Complétion",
  earnedCount: "Nombre Obtenu",
  progressCount: "Nombre En Cours",

  // ========== MESSAGES D'ACCOMPLISSEMENT ==========
  achievementUnlocked: "Accomplissement Débloqué !",
  newBadgeEarned: "Nouveau Badge Obtenu !",
  levelMilestone: "Étape de Niveau !",
  experienceGained: "Expérience gagnée : +{amount}",

  // ========== MESSAGES D'ERREUR ==========
  failedToLoadBadges: "Échec du chargement des badges",
  failedToLoadLevel: "Échec du chargement du niveau",
  failedToLoadProgress: "Échec du chargement de la progression",

  // ========== BOUTONS D'ACTION ==========
  viewDetails: "Voir les Détails",
  trackProgress: "Suivre la Progression",
  shareAchievement: "Partager l'Accomplissement",

  // ========== NOTIFICATIONS ==========
  badgeEarned: "Badge obtenu : {badgeName}",
  levelIncreased: "Niveau supérieur ! Maintenant niveau {level}",
  milestoneReached: "Étape atteinte !",

  // ========== AFFICHAGES COMPACTS ==========
  lvl: "Niv",
  expShort: "EXP",
  badgesShort: "Badges",

  // ========== BARRES DE PROGRESSION ==========
  progressBarLabel: "Progression : {current}/{total}",
  completionRate: "Taux de complétion : {percentage}%",

  // ========== TEMPS ==========
  recentlyUnlocked: "Récemment débloqué",
  timeToUnlock: "Temps pour débloquer",
  earnedToday: "Gagné aujourd'hui",
  earnedThisWeek: "Gagné cette semaine",

  // ========== FILTRES ET TRI ==========
  filterByCategory: "Filtrer par catégorie",
  sortByProgress: "Trier par progression",
  sortByRarity: "Trier par rareté",
  sortByDate: "Trier par date",

  // ========== TEXTE D'AIDE ==========
  howToEarnBadges: "Comment obtenir des badges",
  levelSystemExplanation: "Explication du système de niveau",
  experienceExplanation: "Explication des points d'expérience",

  // ========== ÉVÉNEMENTS SPÉCIAUX ==========
  specialEvent: "Événement Spécial",
  limitedTime: "Temps Limité",
  eventBadge: "Badge d'Événement",
  seasonalBadge: "Badge Saisonnier",

  // ========== TRADUCTIONS PROFIL PUBLIC ==========
  profileTitle: "Profil de {name}",
  playerNotFound: "Joueur non trouvé",
  profilePrivate: "Ce profil est privé",
  failedToLoadProfile: "Échec du chargement du profil",
  playerNotFoundDesc: "Le joueur que vous recherchez n'existe pas ou a été banni.",
  profilePrivateDesc: "Ce joueur a rendu son profil privé.",
  profileLoadError: "Une erreur s'est produite lors du chargement du profil. Veuillez réessayer.",
  yourProfile: "Votre Profil",
  searchOtherPlayer: "Rechercher un autre joueur",
  findPlayer: "Trouver un Joueur",
  searchPlayerDesc: "Recherchez n'importe quel joueur par son nom d'utilisateur ou son nom en jeu pour voir son profil public.",
  loadingProfile: "Chargement du Profil...",
  loadingPlayerProfile: "Chargement du profil du joueur...",
  playerProfiles: "Profils des Joueurs",

  // ========== TRADUCTIONS CLASSEMENT ==========
  wins: "Victoires",
  avgPrize: "Moyenne",
  totalPrize: "Prix Total",
  losses: "Défaites",
  leaderboard: "Classement",
  levelLeaderboard: "Classement par Niveau",
  winsLeaderboard: "Classement par Victoires",
  winStreakLeaderboard: "Classement par Série",
  pointsLeaderboard: "Classement par Points",
  levelLeaderboardDesc: "Meilleurs joueurs classés par points d'expérience et niveau",
  winsLeaderboardDesc: "Meilleurs joueurs classés par victoires totales en tournoi",
  winStreakLeaderboardDesc: "Meilleurs joueurs avec des séries de victoires actuelles",
  pointsLeaderboardDesc: "Meilleurs joueurs classés par solde de points actuel",
  loadingLeaderboard: "Chargement du Classement...",
  loadingRankings: "Chargement des classements des joueurs...",
  failedToLoadLeaderboard: "Échec du chargement du classement",
  leaderboardRefreshed: "Classement actualisé !",
  leaderboardLoadError: "Une erreur s'est produite lors du chargement du classement. Veuillez réessayer.",
  noDataAvailable: "Aucune Donnée Disponible",
  noActiveStreaks: "Aucun joueur n'a actuellement de série de victoires active.",
  noPlayersFound: "Aucun joueur trouvé pour ce classement.",
  fullRankings: "Classements Complets",
  champion: "Champion",
  currentStreak: "Série Actuelle",
  maxStreak: "Max",
  levelDesc: "Par Expérience",
  winsDesc: "Par Victoires",
  winStreakDesc: "Séries Actuelles",
  pointsDesc: "Par Solde",
  lastUpdated: "Dernière mise à jour",
  accountAge: "Âge du compte",
  days: "jours",
  you: "(Vous)",
  searchFromLeaderboard: "Rechercher un joueur...",

  // ========== COMPOSANTS PROFIL AMÉLIORÉS ==========
  profile: "Profil",
  overview: "Aperçu",
  mainAdmin: "Admin Principal",
  supervisor: "Superviseur",
  approver: "Approbateur",
  manager: "Gestionnaire",
  verifiedSponsor: "Sponsor Vérifié",
  player: "Joueur",
  memberSince: "Membre depuis",
  lastSeen: "Dernière visite",
  currentlyOnline: "Actuellement :",
  fillerWins: "Victoires Remplissage",
  bestWinStreak: "Meilleure Série",
  gameModeStats: "Statistiques par Mode",
  accountInformation: "Informations du Compte",
  funStats: "Statistiques Amusantes",
  played: "Joué",
  multiplayerWinRate: "Taux de Victoire Multijoueur",
  battleRoyaleWinRate: "Taux de Victoire Battle Royale",

  // ========== RECHERCHE ET GÉNÉRAL ==========
  search: "Rechercher",
  searchForPlayer: "Rechercher un Joueur",
  searchPlayerPlaceholder: "Rechercher par nom d'utilisateur ou nom en jeu...",
  searching: "Recherche en cours...",
  playersFound: "joueurs trouvés",
  noPlayersFoundQuery: "Aucun joueur trouvé correspondant à \"{query}\"",
  searchTipExact: "Essayez de rechercher avec le nom d'utilisateur ou le nom en jeu exact",
  searchTipUsername: "Rechercher par nom d'utilisateur (ex: @player123)",
  searchTipInGame: "Rechercher par nom en jeu (ex: ProGamer)",
  searchTip: "Utilisez ↑↓ pour naviguer, Entrée pour sélectionner, Échap pour fermer",

  // ========== BADGES ET PROFIL ==========
  badgeCollection: "Collection de Badges",
  earned: "Obtenu",
  categoryBreakdown: "Répartition par Catégorie",
  achievementSummary: "Résumé des Accomplissements",
  badgeSystemNotAvailable: "Le système de badges n'est pas disponible pour ce profil.",
  badgesPrivateDesc: "Ce joueur a rendu sa collection de badges privée.",
  badgesLoadError: "Une erreur s'est produite lors du chargement de la collection de badges.",
  badgeSummaryText: "a obtenu {earned} badges sur {total} disponibles ({percentage}% de complétion). Il a débloqué {categories} catégories différentes et gagné {exp} points d'expérience grâce aux badges.",
  recentlyEarned: "Récemment Obtenu",
  showProgress: "Afficher la Progression",
  categoriesUnlocked: "Catégories",
  totalExpFromBadges: "EXP Total des Badges",

  // ========== HISTORIQUE DES MATCHS ==========
  noMatches: "Aucun Match Trouvé",
  noMatchesDesc: "Ce joueur n'a pas encore terminé de matchs publics.",
  loadingMatches: "Chargement des matchs...",
  total: "Total",
  prizeWon: "Prix Gagné",
  winRate: "Taux de Victoire",
  map: "Carte",
  maxKills: "Kills Max",
  entry: "Entrée",
  prize: "Prix",
  players: "Joueurs",
  by: "par",
  won: "GAGNÉ",
  lost: "PERDU",
  shared: "Partagé",
  thisPlayer: "Ce Joueur",
  matchSummary: "Résumé du Match",
  winLossRecord: "Bilan Victoires/Défaites",
  totalPrizeWon: "Prix Total Gagné",
  averagePrize: "Prix Moyen par Victoire",

  // ========== STATISTIQUES DÉTAILLÉES ==========
  detailedStatistics: "Statistiques Détaillées",
  quickStats: "Stats Rapides",
  overallPerformance: "Performance Globale",
  gameModeBreakdown: "Répartition par Mode",
  pointsStatistics: "Statistiques de Points",
  specialAchievements: "Accomplissements Spéciaux",
  playerSummary: "Résumé du Joueur",
  playerSummaryText: "est un joueur {performance} avec {wins} victoires sur {total} matchs, atteignant un taux de victoire de {winRate}%. Il est actuellement classé #{rank} mondialement.",
  currentStreakText: "Il est actuellement sur une série de {streak} victoires !",
  bestStreakText: "Sa meilleure série était de {streak} victoires consécutives.",
  elite: "Élite",
  pro: "Pro",
  average: "Moyen",
  fillerMaster: "Maître Remplisseur",
  fillerWinsDesc: "A gagné des tournois avec des remplisseurs IA",
  streakWarrior: "Guerrier des Séries",
  streakDesc: "A atteint des séries impressionnantes",
  globalRank: "Rang Mondial",
  byExperience: "Par Expérience",
  currentPoints: "Points Actuels",
  pointsWon: "Points Gagnés",
  pointsLost: "Points Perdus",
  netGain: "Gain Net",
  avgPerWin: "Moy. par victoire",
  fromLosses: "Des défaites",
  pointsPurchased: "Points Achetés",
  teamBased: "Matchs en équipe",
  survivalMode: "Mode survie",
  matchesPlayed: "Matchs Joués",
  totalMatches: "Total Matchs",
  badgesEarned: "Badges Obtenus",
  badgeExp: "EXP Badges",
  categories: "Catégories",

  // ========== RÔLES ==========
  roleChanged: "Votre rôle a été modifié",
  commissionEarned: "Commission Gagnée",
  matchesApproved: "Matchs Approuvés",
  approversManaged: "Approbateurs Gérés",
  roleUpdated: "Rôle Mis à Jour",
  roleChangedTo: "Votre rôle a été changé en",
  changedBy: "Modifié par",
  reason: "Raison",
  commissionRates: "Taux de Commission",

  // ========== NETTOYAGE TOURNOIS ==========
  oldTournamentRemoved: 'Ancien tournoi supprimé automatiquement',
  tournamentsAutoRemoved: '{count} ancien(s) tournoi(s) supprimé(s) du lobby',
  pointsRefunded: '{amount} points remboursés aux joueurs',
  adminCleanupActivity: 'Nettoyage : {deleted} tournois supprimés, {refunded} points remboursés',
  manualCleanupTriggered: 'Nettoyage manuel par {admin} : {deleted} tournois supprimés',
  autoCleanup: 'Nettoyage Auto',
  removes: 'Supprime',
  old: 'ancien',
  cleanupNow: 'Nettoyer Maintenant',
  active: 'Actif',
  stopped: 'Arrêté',
  onlyMainAdminCanCleanup: 'Seuls les admins principaux peuvent déclencher un nettoyage manuel',
  manualCleanupCompleted: 'Nettoyage manuel terminé : {deleted} tournois supprimés',
  manualCleanupFailed: 'Échec du nettoyage manuel',
  tournamentAutoDeleted: 'Tournoi supprimé automatiquement en raison de son âge',
  tournamentDeletedOld: 'Ancien tournoi supprimé du lobby',
  cleanupServiceActive: 'Service de nettoyage actif',
  cleanupServiceStopped: 'Service de nettoyage arrêté',
  tournamentCleanupStatus: 'Statut du Nettoyage des Tournois',
  maxAgeInLobby: 'Âge max dans le lobby',
  cleanupInterval: 'Intervalle de nettoyage',
  lastCleanup: 'Dernier nettoyage',
  nextCleanup: 'Prochain nettoyage',
  tournamentsProcessed: 'Tournois traités',
  totalRefundedAmount: 'Total remboursé',
  cleanupConfiguration: 'Configuration du Nettoyage',
  enableAutoCleanup: 'Activer le nettoyage automatique',
  maxAgeHours: 'Âge maximum (heures)',
  intervalMinutes: 'Intervalle de nettoyage (minutes)',
  maxPerRun: 'Max tournois par exécution',
  enableNotifications: 'Activer les notifications',
  saveConfiguration: 'Sauvegarder la Configuration',
  configurationSaved: 'Configuration sauvegardée avec succès',
  configurationFailed: 'Échec de la sauvegarde de la configuration',
  triggerManualCleanup: 'Déclencher un Nettoyage Manuel',
  cleanupInProgress: 'Nettoyage en cours...',
  cleanupCompleted: 'Nettoyage terminé',
  noOldTournaments: 'Aucun ancien tournoi trouvé',
  cleanupSummary: 'Résumé du Nettoyage',
  deletedCount: 'Supprimé',
  refundedAmount: 'Remboursé',
  errors: 'Erreurs',
  duration: 'Durée',
  tournamentAgeWarning: 'Le tournoi sera supprimé automatiquement dans {time}',
  tournamentAgeInfo: 'Âge du tournoi : {age}',
  autoDeleteIn: 'Suppression auto dans',
  minutes: 'minutes',
  hours: 'heures',

  // ========== GESTION DES REMPLISSEURS ==========
  addFiller: "Ajouter Remplisseur",
  fillerManagement: "GESTION DES REMPLISSEURS",
  fillerPlayers: "Joueurs Remplisseurs",
  fillerName: "Nom du Remplisseur",
  enterFillerName: "Entrez le nom du remplisseur...",
  fillerNameRequired: "Le nom du remplisseur est requis",
  fillerNameTooLong: "Nom trop long (max 20 caractères)",
  fillerNameHelp: "Choisissez un nom unique pour ce joueur IA (max 20 caractères)",
  insufficientPointsForFiller: "Points insuffisants pour ajouter un remplisseur",
  fillerAddedSuccessfully: "Remplisseur \"{name}\" ajouté avec succès !",
  failedToAddFiller: "Échec de l'ajout du remplisseur",
  removeFiller: "Retirer le remplisseur",
  fillerRemoved: "Remplisseur retiré avec succès !",
  fillerRemovedWithRefund: "Remplisseur retiré ! {amount} points remboursés.",
  failedToRemoveFiller: "Échec du retrait du remplisseur",
  yourFiller: "(Votre Remplisseur)",
  needMorePoints: "Il vous faut {amount} points de plus",
  needMoreRealPlayers: "Il faut {count} vrai(s) joueur(s) de plus avant d'ajouter des remplisseurs quand le tournoi est plein",
  needRealPlayersWarning: "Il faut {count} vrai(s) joueur(s) de plus pour ajouter des remplisseurs quand le tournoi est plein",
  free: "GRATUIT",
  cost: "Coût",
  slots: "Places",
  slotRemaining: "place restante",
  slotsRemaining: "places restantes",
  giveawayFillerFree: "C'est un tournoi cadeau - les remplisseurs sont GRATUITS !",
  fillerCostWarning: "Vous paierez {cost} points pour ce remplisseur. S'il gagne, vous recevez le prix !",
  fillerAddedAndTournamentUpdated: "Remplisseur ajouté ! Tournoi mis à jour.",

  // ========== FONCTIONNALITÉ COPIE ==========
  noMatchIdToCopy: "Aucun ID de match à copier",
  matchIdCopied: "ID du match copié !",
  noTournamentIdToCopy: "Aucun ID de tournoi à copier",
  tournamentIdCopied: "ID du tournoi copié !",

  // ========== RECHERCHE ET PAGINATION ==========
  searchFinishedTournaments: "Rechercher par ID de tournoi, créateur, mode ou carte...",
  searchResults: "{count} tournois trouvés",
  noSearchResults: "AUCUN RÉSULTAT",
  tryDifferentSearch: "Essayez un autre terme de recherche ou effacez la recherche",
  previousPage: "Page précédente",
  nextPage: "Page suivante",
  prev: "Préc",
  next: "Suiv",
  pageInfo: "Page {current} sur {total} ({totalItems} total)",

  // ========== PANNEAU ADMIN ==========
  mainAdminPanel: "Panneau Admin Principal",
  commissionSummary: "Résumé des Commissions",
  yourCommissionEarned: "Votre Commission Gagnée",
  asSupervisor: "(en tant que Superviseur)",
  asApprover: "(en tant qu'Approbateur)",
  totalFromUsers: "Total des Utilisateurs",
  totalToApprovers: "Total aux Approbateurs",
  totalToSystem: "Total au Système",

  // ========== ONGLETS ADMIN ==========
  stats: "Stats",
  roles: "Rôles",
  pointsTab: "Points",
  rates: "Taux",
  users: "Utilisateurs",
  approvers: "Approbateurs",
  inbox: "Boîte de Réception",
  pending: "En Attente",
  withdrawals: "Retraits",
  transactionLog: "Transactions",

  // ========== JOURNAL DES TRANSACTIONS ==========
  totalTransactions: "Total des Transactions",
  pointsIn: "Points Entrants",
  pointsOut: "Points Sortants",
  filters: "Filtres",
  hideFilters: "Masquer",
  showFilters: "Afficher",
  transactionType: "Type",
  searchPlaceholder: "Nom d'utilisateur ou description...",
  startDate: "Date de Début",
  endDate: "Date de Fin",
  apply: "Appliquer",
  reset: "Réinitialiser",
  noTransactions: "Aucune transaction trouvée",
  transactionsWillAppear: "Les transactions de points des tournois, achats et actions admin apparaîtront ici.",

  // ========== GESTION DES RÔLES ==========
  userRoleManagement: "Gestion des Rôles Utilisateurs",
  joinDate: "Date d'inscription",
  totalActiveTime: 'Temps total actif',
  avgDailyTime: 'Moy. quotidienne',
  searchUsersModifyRoles: "Recherchez des utilisateurs et modifiez leurs rôles. Seuls les Admins Principaux peuvent changer les rôles.",
  searchUsers: "Rechercher des Utilisateurs",
  searchByUsername: "Rechercher par nom, email ou nom en jeu...",
  selectedUser: "Utilisateur Sélectionné",
  currentRole: "Rôle Actuel",
  newRole: "Nouveau Rôle",
  roleChangePreview: "Changement de Rôle :",
  roleChangeDescription: "Changer le Rôle de l'Utilisateur",
  reasonForChange: "Raison du Changement (Optionnel)",
  enterReasonForRoleChange: "Entrez la raison du changement de rôle...",
  changeUserRole: "Changer le Rôle",
  searchAndSelectUser: "Recherchez et sélectionnez un utilisateur pour gérer son rôle",
  rolePermissionsGuide: "Guide des Permissions",
  fullSystemAccess: "Accès complet au système, peut gérer tous les utilisateurs et paramètres",
  canManageApprovers: "Peut gérer les approbateurs et approuver les tournois",
  canApproveTournaments: "Peut approuver les tournois et gagner des commissions",
  managerAccess: "Accès superviseur plus bannir les utilisateurs et gérer les rôles",
  verifiedSponsorAccess: "Peut créer des tournois cadeaux et des tournois à élimination",
  regularUser: "Utilisateur régulier, peut participer aux tournois",
  cannotBeChanged: "⚠️ Ne peut pas être modifié",

  // ========== GESTION DES POINTS ==========
  pointsManagement: "Gestion des Points",
  searchUsersManagePoints: "Recherchez des utilisateurs et gérez leurs points. Vous pouvez ajouter, retirer ou définir des montants.",
  actionType: "Type d'Action",
  add: "Ajouter",
  remove: "Retirer",
  set: "Définir",
  pointsAmount: "Montant de Points",
  enterPointsAmount: "Entrez le montant de points...",
  reasonOptional: "Raison (Optionnel)",
  enterReasonForPointsAdjustment: "Entrez la raison de l'ajustement...",
  actionAdd: "Ajouter",
  actionRemove: "Retirer",
  actionSet: "Définir",
  pointsToUser: "points à",
  pointsFromUser: "points de",
  pointsForUser: "points pour",
  newBalance: "Nouveau solde :",
  addPoints: "Ajouter des Points",
  removePoints: "Retirer des Points",
  setPoints: "Définir les Points",
  searchAndSelectUserPoints: "Recherchez et sélectionnez un utilisateur pour gérer ses points",

  // ========== PARAMÈTRES DE COMMISSION ==========
  commissionRateSettings: "Paramètres des Taux de Commission",
  multiplayerTournaments: "🎯 Tournois Multijoueur",
  battleRoyaleTournaments: "👑 Tournois Battle Royale",
  approverCommission: "Commission Approbateur (%)",
  systemCommission: "Commission Système (%)",
  updateCommissionRates: "Mettre à Jour les Taux",
  updating: "Mise à jour...",

  // ========== GESTION DES UTILISATEURS ==========
  allUsers: "Tous les Utilisateurs",
  ban: "Bannir",
  unban: "Débannir",

  // ========== GESTION DES APPROBATEURS ==========
  addNewApprover: "Ajouter un Nouvel Approbateur",
  multiplayerCommissionRange: "Commission Multijoueur (0-{max}%) :",
  battleRoyaleCommissionRange: "Commission Battle Royale (0-{max}%) :",
  addAsApprover: "Ajouter comme Approbateur",
  adding: "Ajout en cours...",
  myApprovers: "Mes Approbateurs",
  noApproversAdded: "Aucun approbateur ajouté.",

  // ========== GESTION DES TOURNOIS ==========
  matchesReadyForApproval: "Matchs Prêts pour Approbation",
  youCanOnlySeeMatches: "ℹ️ Vous ne voyez que les matchs non réclamés par d'autres {role} ou ceux que vous avez commencé à approuver.",
  supervisors: "superviseurs",
  approversLower: "approbateurs",
  noMatchesReady: "Aucun match prêt pour approbation.",
  othersMayHaveClaimed: "D'autres {role} ont peut-être réclamé les matchs disponibles.",
  enterMatchIdFromCod: "Entrez l'ID du Match de CoD Mobile",
  approve: "Approuver",
  approving: "Approbation...",
  startedBy: "⚠️ Commencé par :",
  assignedToBot: 'Assigné au Bot',

  // ========== MATCHS ACTIFS ==========
  activeMatches: "Matchs Actifs",
  youCanOnlyManageMatches: "ℹ️ Vous ne voyez et gérez que les matchs que vous avez personnellement approuvés.",
  noActiveMatches: "Aucun match actif.",
  haventApprovedMatches: "Vous n'avez pas encore approuvé de matchs ou ils ont été complétés.",
  roomLabel: "🎮 ID Salon",
  generating: "Génération...",
  noAccess: "🔒 PAS D'ACCÈS",
  notInTournament: "Pas dans ce tournoi",
  copyId: "COPIER ID",
  joinRoom: "REJOINDRE",
  roomUrl: "URL de la Salle",
  enterRoomUrl: "https://... (lien optionnel pour rejoindre la salle)",
  roomUrlDescription: "Si fourni, les joueurs verront un bouton 'Rejoindre'",
  edit: "MODIFIER",
  cancel: "ANNULER",
  standby: "⏱️ EN ATTENTE",
  activeBadge: "🔥 ACTIF",
  joined: "✓ REJOINT",
  selectWinners: "Sélectionner Gagnant",
  selectWinnersPlural: "Sélectionner Gagnants",
  readyForSelection: "⚡ Prêt pour sélection",
  completeMatch: "Terminer le Match",
  completing: "Finalisation...",
  winner: "gagnant",
  winners: "gagnants",
  teamModeInfo: "ℹ️ {mode} : Sélectionnez {count} gagnant(s) de l'équipe gagnante",
  duos: "Duos",
  squads: "Escouades",
  teamMode: "Équipe",
  winnerSelectionAvailable: "⚡ La sélection du gagnant est disponible. Le compte à rebours est juste la limite pour les joueurs.",

  // ========== MODIFIER ID MATCH ==========
  editMatchId: "Modifier l'ID du Match",
  currentMatchId: "ID du Match Actuel :",
  newMatchId: "Nouvel ID du Match",
  enterNewMatchId: "Entrez le nouvel ID du match de CoD Mobile",
  matchIdCannotBeEmpty: "L'ID du match ne peut pas être vide",
  matchIdTooLong: "L'ID du match doit faire moins de 50 caractères",
  sameAsCurrentMatchId: "Le nouvel ID est identique à l'actuel",
  validNewMatchId: "✓ Nouvel ID valide",
  matchIdHistory: "Historique des ID :",
  current: "(actuel)",
  changingMatchIdNotification: "⚠️ Changer l'ID notifiera tous les participants. Assurez-vous que le nouvel ID est correct.",
  updateMatchId: "Mettre à Jour l'ID",
  updateMatching: "Mise à jour...",

  // ========== ANNULER TOURNOI ==========
  cancelTournament: "Annuler le Tournoi",
  cancellationReason: "Raison de l'Annulation",
  enterReasonForCancelling: "Entrez la raison de l'annulation de ce tournoi...",
  refundInformation: "⚠️ Informations de Remboursement :",
  creatorWillReceive: "Le créateur recevra",
  pointsBack: "points remboursés",
  eachParticipantWillReceive: "Chaque participant recevra ses",
  entryFeeBack: "frais d'entrée remboursés",
  totalRefund: "Remboursement total",
  giveawayIndicator: "🎁 Tournoi Cadeau",
  thisActionCannotBeUndone: "⚠️ Cette action est irréversible. Tous les participants seront remboursés et le tournoi sera définitivement annulé.",
  confirmCancellation: "Confirmer l'Annulation",
  cancelling: "Annulation...",
  keepTournament: "Garder le Tournoi",

  // ========== DEMANDES DE RETRAIT ==========
  withdrawalRequests: "Demandes de Retrait",
  noPendingRequests: "Aucune demande en attente.",
  pointsToAmount: "{points} Points → ${amount}",

  // ========== MODALES DE CONFIRMATION ==========
  confirmRoleChange: "Confirmer le Changement de Rôle",
  roleChangeFromTo: "{currentRole} → {newRole}",
  thisActionWillImmediately: "⚠️ Cette action changera immédiatement le rôle et les permissions de l'utilisateur. L'utilisateur sera notifié.",
  confirmChange: "Confirmer le Changement",
  changingRole: "Changement du Rôle...",

  // ========== CONFIRMATION POINTS ==========
  confirmPointsAction: "Confirmer {action} des Points",
  pointsAction: "Action :",
  actionDescription: "{action} {amount} points {preposition} {username}",
  prepositionTo: "à",
  prepositionFrom: "de",
  prepositionFor: "pour",
  thisActionWillUpdatePoints: "⚠️ Cette action mettra immédiatement à jour le solde de points. Assurez-vous que le montant est correct.",
  confirmAction: "Confirmer {action}",
  processing: "Traitement...",

  // ========== CONFIRMATION GÉNÉRALE ==========
  changeUserRoleQuestion: "Changer le rôle ?",
  banUserQuestion: "Bannir l'utilisateur ?",
  unbanUserQuestion: "Débannir l'utilisateur ?",
  removeApproverQuestion: "Retirer l'approbateur ?",

  // ========== NOTIFICATIONS ET MESSAGES ==========
  roleChangedSuccessfully: "Rôle de {username} changé en {role} avec succès",
  pointsAddedSuccessfully: "{points} points ajoutés à {username} avec succès",
  pointsRemovedSuccessfully: "{points} points retirés de {username} avec succès",
  pointsSetSuccessfully: "{points} points définis pour {username} avec succès",
  matchIdUpdatedSuccessfully: "ID du match mis à jour avec succès",
  tournamentCancelledSuccessfully: "Tournoi annulé avec succès. {refundInfo}",
  commissionRatesUpdated: "Taux de commission mis à jour avec succès !",
  userBannedSuccessfully: "{username} a été banni avec succès !",
  userUnbannedSuccessfully: "{username} a été débanni avec succès !",
  approverAddedSuccessfully: "Approbateur ajouté avec succès !",
  approverRemovedSuccessfully: "{username} retiré du rôle d'approbateur avec succès !",
  matchApprovedSuccessfully: "Match approuvé avec succès !",
  matchCompletedSuccessfully: "Match terminé avec succès !",
  withdrawalProcessedSuccessfully: "Demande de retrait {status} avec succès !",

  // ========== MESSAGES D'ERREUR ==========
  failedToLoadAdminData: "Échec du chargement des données admin",
  failedToChangeUserRole: "Échec du changement de rôle",
  failedToManagePoints: "Échec de la gestion des points",
  failedToUpdateMatchId: "Échec de la mise à jour de l'ID",
  failedToCancelTournament: "Échec de l'annulation du tournoi",
  failedToUpdateCommissionRates: "Échec de la mise à jour des taux",
  failedToProcessWithdrawal: "Échec du traitement du retrait",
  failedToSearchUsers: "Échec de la recherche",
  invalidUserOrRole: "Utilisateur ou rôle invalide",
  userAlreadyHasRole: "L'utilisateur a déjà ce rôle",
  pleaseSelectUser: "Veuillez d'abord sélectionner un utilisateur",
  pleaseEnterValidAmount: "Veuillez entrer un montant valide",
  pleaseEnterMatchId: "Veuillez entrer un ID de match !",
  pleaseSelectWinner: "Veuillez sélectionner au moins un gagnant !",
  unknownAction: "Action inconnue : {action}",

  // ========== ÉTIQUETTES DE FORMULAIRE ==========
  searchResultsCount: "Résultats ({count})",

  // ========== INDICATEURS DE STATUT ==========
  banned: "BANNI",
  approved: "APPROUVÉ",
  rejected: "REJETÉ",

  // ========== CRÉATION DE TOURNOI ==========
  upTo: "Jusqu'à",
  createTournament: "Créer un Tournoi",
  tournamentType: "Type de Tournoi",
  regularTournament: "🏆 Tournoi Régulier",
  giveawayTournament: "🎁 Tournoi Cadeau (Entrée Gratuite)",

  // Options de participation du créateur de cadeau
  creatorParticipation: "Votre Participation",
  joinAndPlay: "Rejoindre et Jouer",
  joinAndPlayDesc: "Vous participez au match",
  spectateGame: "Regarder la Partie",
  spectateGameDesc: "Regarder le match en spectateur",
  sponsorOnly: "Sponsor Uniquement",
  sponsorOnlyDesc: "Financez juste le prix, les autres jouent",
  spectateInfo: "Vous serez dans le jeu en tant que SPECTATEUR. Vous pouvez regarder mais pas jouer. Toutes les places sont ouvertes aux autres.",
  sponsorInfo: "Vous ne serez PAS ajouté au match. Toutes les places sont ouvertes aux autres joueurs.",
  spectator: "SPECTATEUR",

  gameMode: "Mode de Jeu",
  multiplayerType: "Type de Match",
  battleRoyaleType: "Type Battle Royale",
  teamMatch: "Match en Équipe",
  customMode: "Mode Personnalisé",
  solo: "Solo",
  duo: "Duo",
  squad: "Escouade",
  team: "Équipe",
  entryFee: "Frais d'Entrée",
  totalPrizePool: "Cagnotte Totale",
  roomPassword: "Mot de Passe du Salon",
  optional: "Optionnel",
  estimatedPrizePool: "Cagnotte Estimée",
  totalEntryFees: "Total des Frais d'Entrée",
  commission: "Commission",
  yourEntryFee: "Vos Frais d'Entrée",
  yourTotalCost: "Votre Coût Total",
  entryFeeForPlayers: "Frais d'Entrée pour les Joueurs",
  insufficientPoints: "Points insuffisants !",
  createTournamentBtn: "Créer le Tournoi",
  createRegularTournament: "Créer le Tournoi",
  createGiveawayTournament: "Créer Tournoi Cadeau",
  createQuickSolo: "Créer Solo Rapide",
  creating: "Création...",
  minimize: "Réduire",
  expandChat: "Agrandir le chat",
  minimizeChat: "Réduire le chat",
  closeChat: "Fermer le chat",
  prizePoolForWinners: "Cagnotte pour les Gagnants",
  howItWorks: "Comment ça marche",
  howItWorksQuickSolo: "Match 1v1 rapide sur Shipment. Premier à {kills} kills ou meilleur score à {time} gagne !",
  howItWorksGiveaway: "Vous payez {cost} points ({prize} prix + {commission} commission). Les joueurs rejoignent gratuitement. Le(s) gagnant(s) reçoivent exactement {prizePool} points.",
  howItWorksRegular: "Total des frais d'entrée : {totalEntry} pts. Après {commissionRate}% de commission, la cagnotte est de {prizePool} pts.",
  locked: "Verrouillé",

  // ========== SOLO RAPIDE ==========
  quickSolo: "⚡ Solo Rapide (1v1)",
  quickSoloTournament: "Tournoi Solo Rapide",
  killLimit: "Limite de Kills",
  timeLimit: "Limite de Temps",
  timeLimitSeconds: "Limite de Temps (secondes)",
  weaponRestrictions: "Restrictions d'Armes (Optionnel)",
  selectAllowedWeapons: "Sélectionnez les types d'armes autorisés (laissez vide pour toutes)",
  selectedWeapons: "Types d'Armes Sélectionnés",
  allWeaponsAllowed: "Toutes les armes autorisées - aucune restriction",
  weaponRestrictionsWarning: "⚠️ Utiliser des armes interdites entraînera une disqualification immédiate !",
  allowedWeaponsOnly: "Seules ces armes sont autorisées :",
  quickSoloInfo: "Solo Rapide : Matchs 1v1 rapides sur Shipment uniquement. Parfait pour des duels de points rapides !",

  // ========== TYPES D'ARMES ==========
  boltActionSniper: "Sniper/Tireur d'Élite à Verrou",
  shotgun: "Fusil à Pompe",
  assault: "Assaut",
  smg: "Mitraillette",

  // ========== STATUTS DE TOURNOI ==========
  lobby: "LOBBY",
  wait: "ATTENTE",
  activeStatus: "ACTIF",
  finish: "TERMINÉ",
  deploying: "DÉPLOIEMENT",
  standbyStatus: "EN ATTENTE",
  completed: "TERMINÉ",
  cancelled: "ANNULÉ",
  autoCanceled: "AUTO-ANNULÉ",

  // ========== ACTIONS DE TOURNOI ==========
  join: "REJOINDRE",
  abort: "ABANDONNER",
  copy: "COPIER",
  deploy: "DÉPLOYER",

  // ========== MODAL REJOINDRE ÉQUIPE BR ==========
  selectTeamPreference: "Sélectionner la Préférence d'Équipe",
  selectTeam: "Sélectionner Votre Équipe",
  preference: "Préférence",
  soloTournament: "Tournoi Solo",
  soloTournamentDesc: "Ce tournoi exige que tous les joueurs jouent seuls. Pas de coéquipiers autorisés.",
  randomTournament: "Tournoi Équipe Ouverte",
  randomTournamentDesc: "N'importe quel joueur peut rejoindre et faire équipe avec d'autres. Choisissez votre préférence ci-dessous.",
  squadTournament: "Tournoi Escouade",
  squadTournamentDesc: "Le créateur a spécifié des coéquipiers. Vous pouvez former votre propre escouade ou rejoindre en aléatoire.",
  teamTournament: "Tournoi d'Équipe",
  creatorSquadmates: "Coéquipiers du Créateur:",
  duoTeamInfo: "Choisissez comment vous voulez jouer dans ce tournoi Duo",
  squadTeamInfo: "Choisissez comment vous voulez jouer dans ce tournoi Escouade",
  yourTeamPreference: "Votre Préférence d'Équipe",
  soloTeam: "👤 Solo - Pas de coéquipiers",
  soloLockedReason: "Le créateur du tournoi a défini le mode Solo - tous les joueurs doivent jouer seuls.",
  randomTeam: "🎲 Aléatoire - N'importe quel joueur peut rejoindre",
  squadTeam: "👥 Escouade - Choisir des coéquipiers spécifiques",
  selectSquadmates: "Sélectionner les Coéquipiers",
  randomPlayer: "🎲 Joueur Aléatoire",
  playerName: "Nom du Joueur",
  specific: "Joueur Spécifique",
  squadHelpText: "Basculer entre nom de joueur spécifique, joueur aléatoire ou emplacement vide",
  soloInfo: "Vous jouerez seul. Personne ne peut rejoindre votre équipe.",
  randomInfo: "N'importe quel joueur disponible peut rejoindre votre équipe.",
  selectTeamToJoin: "Sélectionnez l'équipe que vous voulez rejoindre. Les équipes indisponibles ont des restrictions.",
  randomPreference: "Préférence Coéquipier Aléatoire",
  squadPreference: "Préférence Escouade",
  noAvailableTeams: "Pas d'équipes disponibles. Toutes les équipes sont pleines ou ont des restrictions.",
  soloPlayerTeam: "Joueur Solo",
  squadOnly: "Escouade Uniquement",
  available: "Disponible",
  spot: "place",
  spots: "places",
  back: "Retour",

  // ========== SÉLECTION D'ÉQUIPE MP ==========
  captainSettings: "Paramètres du Capitaine d'Équipe",
  captainSettingsInfo: "En tant que capitaine, choisissez qui peut rejoindre votre équipe",
  teamJoinMode: "Mode de Rejoindre l'Équipe",
  randomTeammates: "Aléatoire - N'importe qui peut rejoindre",
  specificTeammates: "Spécifique - Choisir les coéquipiers",
  selectTeammates: "Sélectionner les Coéquipiers (par nom en jeu)",
  slot: "Emplacement",
  clickToEmpty: "Cliquez pour laisser vide",
  clickForRandom: "Cliquez pour aléatoire",
  setRandom: "Définir Aléatoire",
  enterInGameName: "Entrez le nom en jeu",
  anyPlayerCanJoin: "N'importe quel joueur peut rejoindre cet emplacement",
  teammatesNote: "Laissez les emplacements vides pour empêcher les autres de rejoindre",
  randomTeamInfo: "N'importe quel joueur pourra rejoindre votre équipe",
  youWillBeCaptain: "Vous serez le capitaine de l'équipe",
  youAreInvited: "Vous êtes invité à cette équipe",
  joiningViaRandomSlot: "Rejoindre via un emplacement aléatoire",
  teamNotAccepting: "Cette équipe n'accepte pas de joueurs",
  notOnInviteList: "Vous n'êtes pas sur la liste d'invités de cette équipe",
  invitedPlayers: "Joueurs invités :",
  createTeam: "Créer l'Équipe",
  mpTeamSelectInfo: "Choisissez quelle équipe rejoindre pour ce match",
  teamRestriction: "Restriction d'Équipe",
  teamSelectionHeading: "Sélection d'Équipe",
  randomTeam: "Équipe Aléatoire",
  specificTeam: "Équipe Spécifique",

  // ========== DÉTAILS DU TOURNOI ==========
  giveaway: "CADEAU",
  highStakes: "ENJEUX ÉLEVÉS",
  veryHighStakes: "TRÈS HAUTS ENJEUX",
  legendaryStakes: "ENJEUX LÉGENDAIRES",
  passwordProtected: "🔒MDP",
  roomId: "🎮 SALON",
  matchLive: "MATCH EN COURS",
  tournamentId: "ID du Tournoi",
  copyTournamentId: "Copier l'ID du Tournoi",

  // ========== OPÉRATIONS DE TOURNOI ==========
  tournamentOps: "OPS TOURNOI",
  intelUpdated: "Intel mis à jour !",
  noActiveLobies: "PAS DE LOBBIES ACTIFS",
  deployFirstTournament: "Déployez le premier tournoi !",
  noPendingDeployments: "PAS DE DÉPLOIEMENTS EN ATTENTE",
  fullLobbiesAppear: "Les lobbies pleins apparaîtront ici (annulation auto après 30min)",
  noActiveOperations: "PAS D'OPÉRATIONS ACTIVES",
  deployedTournamentsAppear: "Les tournois déployés apparaîtront ici",
  noCompletedMissions: "PAS DE MISSIONS TERMINÉES",
  finishedCancelledAppear: "Les tournois terminés et annulés apparaîtront ici",
  noData: "PAS DE DONNÉES",
  nothingToShow: "Rien à afficher",
  refresh: "ACTUALISER",

  // ========== SYSTÈME DE CHAT ==========
  chat: "Chat",
  searchPlayers: "Rechercher des joueurs...",
  noPlayersOnline: "Aucun autre joueur en ligne",
  noPlayersMatch: "Aucun joueur ne correspond à votre recherche",
  sendMessage: "Envoyer",
  messageUser: "Message",
  typing: "écrit...",
  connected: "Connecté au serveur !",
  hasUnread: "a des non lus",
  newMessage: "Nouveau Message",
  from: "de",
  in: "dans",

  // ========== POINTS ET PROFIL ==========
  estimatedValue: "Valeur Estimée",
  buyPoints: "Acheter des Points",
  withdraw: "Retirer",
  minimumWithdrawal: "Le montant minimum de retrait est de 1000 points (1,00$)",
  profileManagement: "Gestion du Profil",
  editProfile: "Modifier le Profil",
  changePassword: "Changer le Mot de Passe",
  updateProfile: "Mettre à Jour le Profil",

  // ========== RETRAIT ==========
  requestWithdrawal: "Demander un Retrait",
  pointsToWithdraw: "Points à Retirer",
  paypalEmail: "E-mail PayPal",
  youllReceive: "Vous recevrez",
  platformFee: "frais de plateforme",
  withdrawalInfo: "Infos de Retrait",
  minimum: "Minimum",
  submitRequest: "Soumettre la Demande",
  withdrawalMinimum: "Minimum: 1000 points ($9.50)",
  withdrawalFee: "Frais de plateforme: 5%",
  withdrawalProcessing: "Traitement: 24-96 heures",
  feePercent: "frais de 5%",
  info: "Info",
  submitting: "Envoi en cours...",
  submitting: "Envoi...",
  leaveEmptyToUse: "Laissez vide pour utiliser votre e-mail de compte",
  withdrawalHistory: "Historique des Retraits",
  noWithdrawalRequests: "Pas encore de demandes de retrait.",
  note: "Note",

  // ========== GESTION DU PROFIL ==========
  currentPassword: "Mot de Passe Actuel",
  newPassword: "Nouveau Mot de Passe",
  confirmNewPassword: "Confirmer le Nouveau Mot de Passe",
  enterCurrentPassword: "Entrez votre mot de passe actuel",
  enterNewPassword: "Entrez le nouveau mot de passe (min 6 caractères)",
  confirmYourNewPassword: "Confirmez votre nouveau mot de passe",
  passwordsMatch: "✓ Les mots de passe correspondent",
  passwordsDoNotMatch: "✗ Les mots de passe ne correspondent pas",
  securityTips: "Conseils de Sécurité",
  useAtLeast8Characters: "Utilisez au moins 8 caractères",
  includeUppercaseLowercase: "Incluez majuscules et minuscules",
  addNumbersSpecialChars: "Ajoutez des chiffres et caractères spéciaux",
  dontUsePersonalInfo: "N'utilisez pas d'informations personnelles",
  changing: "Modification...",
  makesSureThisMatches: "⚠️ Assurez-vous que ceci correspond exactement à votre nom en jeu CoD Mobile !",
  passwordStrength: "Force du Mot de Passe",
  weak: "Faible",
  medium: "Moyen",
  strong: "Fort",
  useUppercaseLowercase: "Utilisez majuscules, minuscules, chiffres et symboles pour un mot de passe plus fort",
  testCurrentPassword: "Tester le Mot de Passe Actuel",

  // ========== HISTORIQUE DES MATCHS ==========
  yourMatchHistory: "Votre Historique de Matchs",
  noCompletedMatches: "Pas encore de matchs terminés.",
  joinTournamentsHistory: "Rejoignez des tournois pour construire votre historique !",
  entryFeeLabel: "Entrée",
  prizeLabel: "Prix",
  dateLabel: "Date",
  match: "Match",
  mode: "Mode",
  date: "Date",
  pts: "pts",
  split: "Partagé",
  ways: "parts",
  loadingMatchHistory: "Chargement de l'historique...",

  // ========== SYSTÈME DE BOÎTE DE RÉCEPTION ==========
  supportInbox: "Boîte de Support",
  newReport: "Nouveau Rapport",
  submitNewSupportReport: "Soumettre un Nouveau Rapport",
  subject: "Sujet",
  description: "Description",
  submitReport: "Soumettre le Rapport",
  noCasesYet: "Pas encore de cas de support",
  createNewReport: "Créez un nouveau rapport si vous avez besoin d'aide avec les tournois, paiements ou problèmes de compte.",
  submitFirstReport: "Soumettre Votre Premier Rapport",
  open: "Ouvert",
  closed: "Fermé",
  beforeSubmitting: "Avant de soumettre :",
  beAsDetailed: "• Soyez aussi détaillé que possible dans votre description",
  includeRelevantUsernames: "• Incluez les noms d'utilisateur ou IDs de tournoi pertinents",
  supportTeamWillReview: "• Notre équipe de support examinera et répondra sous 24 heures",
  minimumCharactersRequired: "Minimum 5 caractères requis",
  minimum10CharactersRequired: "Minimum 10 caractères requis",
  submissionProcess: "Processus de Soumission :",
  reportWillBeSubmitted: "Votre rapport sera soumis comme fermé initialement et examiné par notre équipe. Une fois examiné, ils peuvent le rouvrir pour permettre d'autres communications si nécessaire.",
  typeYourMessage: "Tapez votre message...",
  sending: "Envoi...",
  send: "Envoyer",
  pressEnterShift: "Appuyez sur Entrée + Maj pour nouvelle ligne",
  caseNumber: "Cas",
  updated: "Mis à jour",
  messages: "messages",
  clickToView: "Cliquez pour voir la conversation",
  thisCaseIsClosed: "Ce cas est fermé. Vous ne pouvez pas répondre aux cas fermés.",
  activeMatchDetails: "Détails du Match Actif",
  matchSettings: "🏆 Paramètres du Match",
  teamMembers: "👥 Membres de l'Équipe",
  type: "Type",

  // ========== PANNEAU ADMIN BOÎTE DE RÉCEPTION ==========
  supportInboxManagement: "Gestion de la Boîte de Support",
  createCase: "Créer un Cas",
  totalCases: "Total des Cas",
  openCases: "Cas Ouverts",
  closedCases: "Cas Fermés",
  allStatus: "Tous les Statuts",
  allAssignments: "Toutes les Assignations",
  unassigned: "Non Assigné",
  assignedToMe: "Assigné à Moi",
  loadingCases: "Chargement des cas...",
  noCasesFound: "Aucun cas trouvé",
  adjustFiltersOrCreateCase: "Ajustez les filtres ou créez un nouveau cas",

  // Traductions de base manquantes
  unknown: "Inconnu",
  mins: "min",
  hrs: "h",
  daysShort: "j",
  ago: "il y a",
  warning: "Avertissement",
  view: "Voir",
  viewCase: "Voir",
  created: "Créé",
  createNewCaseForUser: "Créer un Nouveau Cas pour un Utilisateur",
  selectUser: "Sélectionner un Utilisateur",
  searchUsersUsername: "Rechercher par nom, email ou nom en jeu...",
  selected: "Sélectionné :",
  initialMessage: "Message Initial",
  caseSubject: "Sujet du cas...",
  initialMessageToUser: "Message initial à l'utilisateur...",
  createCaseBtn: "Créer le Cas",
  closeCase: "Fermer le Cas",
  openCase: "Ouvrir le Cas",
  assignToMe: "M'assigner",
  unassignCase: "Désassigner",
  deleteCase: "Supprimer le Cas",
  assignedTo: "Assigné à :",
  systemMessage: "Système",
  typeYourResponse: "Tapez votre réponse...",
  deleteCaseModal: "Supprimer le Cas",
  deleteCaseWarning: "Avertissement :",
  deleteCaseText: "Cette action est irréversible. Le cas et tous ses messages seront définitivement supprimés.",
  deleting: "Suppression...",
  youAreCurrentlyViewing: "📝 Vous consultez actuellement ce cas",
  youAreViewingCasesList: "📋 Vous consultez la liste des cas",
  afterDeletionReturn: "Après suppression, vous retournerez à la liste des cas",
  listWillRefresh: "La liste sera actualisée après suppression",
  caseLabel: "Cas :",
  userLabel: "Utilisateur :",
  messagesLabel: "Messages :",
  newReportFrom: "Nouveau rapport de {user} : {subject}",
  newMessageInCase: "Nouveau message dans le cas {caseNumber}",
  caseAssignedToYou: "Cas {caseNumber} vous a été assigné",
  pleaseFillAllFields: "Veuillez remplir tous les champs",
  caseCreatedSuccessfully: "Cas créé avec succès",
  failedToCreateCase: "Échec de la création du cas",
  pleaseEnterMessage: "Veuillez entrer un message",
  failedToSendMessage: "Échec de l'envoi du message",
  caseStatusSuccessfully: "Cas {status} avec succès",
  failedToUpdateCaseStatus: "Échec de la mise à jour du statut",
  caseAssignedSuccessfully: "Cas assigné avec succès",
  caseUnassignedSuccessfully: "Cas désassigné avec succès",
  failedToAssignCase: "Échec de l'assignation du cas",
  caseDeletedSuccessfully: "Cas supprimé avec succès",
  failedToDeleteCase: "Échec de la suppression du cas",
  noCaseSelectedForDeletion: "Aucun cas sélectionné pour suppression",
  noCaseSelected: "Aucun cas sélectionné",
  reasonForClosing: "Raison de la fermeture de ce cas :",
  reasonForOpening: "Raison de l'ouverture de ce cas :",
  closing: "fermeture",
  opening: "ouverture",
  assignment: "Assignation",
  status: "Statut",
  user: "Utilisateur",
  createdLabel: "Créé",
  updatedLabel: "Mis à jour",
  emptyStateTitle: "Aucun cas trouvé",
  emptyStateText: "Ajustez les filtres ou créez un nouveau cas",

  // ========== MESSAGES D'ERREUR BOÎTE DE RÉCEPTION ==========
  failedToLoadInbox: "Échec du chargement de la boîte de réception",
  failedToLoadCase: "Échec du chargement du cas",
  pleaseFillBothFields: "Veuillez remplir le sujet et la description",
  subjectMinLength: "Le sujet doit avoir au moins 5 caractères",
  descriptionMinLength: "La description doit avoir au moins 10 caractères",
  reportSubmittedSuccessfully: "Rapport soumis avec succès",
  failedToSubmitReport: "Échec de la soumission du rapport",
  messageTooLong: "Message trop long (max 1000 caractères)",
  briefDescriptionPlaceholder: "Brève description de votre problème...",
  detailedDescriptionPlaceholder: "Veuillez fournir des informations détaillées sur votre problème, y compris les noms d'utilisateur pertinents, IDs de tournoi ou étapes pour reproduire le problème...",
  hasBeenLabel: "a été",
  reopened: "rouvert",
  yourCase: "Votre cas",
  hasBeenDeleted: "a été supprimé par",

  // ========== SYSTÈME DE PAIEMENT ==========
  buyTournamentPoints: "Acheter des Points de Tournoi",
  chooseYourPerfectPackage: "Choisissez votre forfait parfait et commencez à concourir !",
  selectYourPackage: "Sélectionnez Votre Forfait",
  chooseTheAmountOfPoints: "Choisissez le montant de points qui correspond à vos besoins de jeu",
  instantDelivery: "Livraison instantanée",
  securePayment: "Paiement sécurisé",
  noExpiration: "Sans expiration",
  securePaymentInfo: "Informations de Paiement Sécurisé",
  processingPayment: "Traitement du Paiement...",
  yourPaymentProcessedSecurely: "Votre paiement est traité de manière sécurisée par PayPal",
  pointsAddedInstantly: "Les points sont ajoutés instantanément à votre compte",
  allTransactionsEncrypted: "Toutes les transactions sont cryptées et sécurisées",
  noHiddenFeesOrCharges: "Pas de frais cachés",
  pointsPerDollar: "points par $",

  // ========== DESCRIPTIONS DES FORFAITS ==========
  perfectForTryingOut: "Parfait pour essayer",
  bestValueForBeginners: "Meilleur rapport pour débutants",
  seriousPlayersChoice: "Choix des joueurs sérieux",
  tournamentReady: "Prêt pour les tournois",
  competitiveEdge: "Avantage compétitif",
  proTournamentBundle: "Pack pro tournoi",
  maximumValuePack: "Pack valeur maximale",

  // ========== BADGES DE FORFAIT ==========
  starter: "Débutant",
  basic: "Basique",
  mostPopular: "Plus Populaire",
  greatValue: "Super Valeur",
  powerPack: "Pack Puissance",
  ultimate: "Ultime",
  megaPack: "Méga Pack",

  // ========== INSTRUCTIONS D'ACHAT ==========
  howToPurchase: "Comment Acheter",
  selectPackage: "Sélectionner le Forfait",
  chooseYourPreferredPackage: "Choisissez votre forfait préféré ci-dessus",
  clickPayPal: "Cliquer sur PayPal",
  proceedWithSecureCheckout: "Procédez au paiement sécurisé PayPal",
  completePayment: "Finaliser le Paiement",
  finishTransactionViaPayPal: "Terminez la transaction via PayPal",
  pointsAddedImmediatelyToAccount: "Points ajoutés immédiatement à votre compte",

  // ========== MODES DE TOURNOI ==========
  snipersOnly: "SNIPERS UNIQUEMENT",
  rifleOnly: "FUSILS UNIQUEMENT",
  knifeOnly: "MÊLÉE UNIQUEMENT",
  executionOnly: "EXÉCUTION UNIQUEMENT",
  grenadesOnly: "EXPLOSIFS UNIQUEMENT",
  snipers: "SNIPERS",
  rifles: "FUSILS",
  melee: "MÊLÉE",
  execution: "EXÉCUTION",
  explosives: "EXPLOSIFS",
  custom: "Personnalisé",
  ffa: "CPS",

  // ========== MODES DE JEU ==========
  teamDeathmatch: "⚔️ Match à Mort en Équipe",
  domination: "🏁 Domination",
  searchAndDestroy: "💣 Recherche et Destruction",
  hardpoint: "📍 Point Dur",
  killConfirmed: "🏷️ Élimination Confirmée",
  captureTheFlag: "🚩 Capture du Drapeau",
  frontline: "⚡ Ligne de Front",
  freeForAll: "🎯 Chacun pour Soi",
  gunGame: "🔫 Gun Game",
  sticksAndStones: "Bâtons et Pierres",
  oneShotOneKill: "🎯 Un Tir Un Kill",
  cranked: "⚡ Cranked",
  rapidFire: "💨 Tir Rapide",
  attackOfTheUndead: "🧟 Attaque des Morts-Vivants",

  // ========== ÉTIQUETTES GÉNÉRALES ==========
  tournament: "Tournoi",
  random: "Aléatoire",

  // ========== CARTES ==========
  randomMap: "🎲 Carte Aléatoire",

  // ========== MODAL MOT DE PASSE ==========
  passwordProtectedTournament: "🔒 TOURNOI PROTÉGÉ PAR MOT DE PASSE 🔒",
  tournamentPasswordProtected: "Ce tournoi est protégé par mot de passe. Vous avez besoin du bon mot de passe pour rejoindre.",
  enterPassword: "Entrez le Mot de Passe",

  // ========== MODAL BANNISSEMENT ==========
  accountBanned: "🚫 Compte Banni 🚫",
  accountBannedDesc: "Votre compte a été banni et ne peut pas se connecter.",
  bannedBy: "Banni par",
  contactSupport: "Contactez le support si vous pensez qu'il s'agit d'une erreur.",
  understood: "Compris",

  // ========== VALIDATION DE FORMULAIRE ==========
  fieldRequired: "Ce champ est requis",
  invalidEmail: "Veuillez entrer une adresse e-mail valide",
  passwordTooShort: "Le mot de passe doit avoir au moins 6 caractères",
  usernameMinLength: "Le nom d'utilisateur doit avoir au moins 3 caractères",
  usernameMaxLength: "Le nom d'utilisateur doit avoir moins de 20 caractères",
  invalidCharacters: "Contient des caractères invalides",
  fieldTooLong: "Ce champ est trop long",
  fieldTooShort: "Ce champ est trop court",
  numberRequired: "Veuillez entrer un nombre valide",
  numberTooLow: "Nombre trop bas",
  numberTooHigh: "Nombre trop élevé",

  // ========== ERREURS ET MESSAGES GÉNÉRAUX ==========
  error: "Erreur",
  success: "Succès",
  info: "Info",
  failed: "Échec",
  retry: "Réessayer",
  confirm: "Confirmer",

  // ========== ACTIONS GÉNÉRALES ==========
  save: "Sauvegarder",
  delete: "Supprimer",
  update: "Mettre à Jour",
  submit: "Soumettre",
  reject: "Rejeter",

  // ========== TRADUCTIONS ADMIN MANQUANTES ==========
  banUser: "Bannir l'Utilisateur",
  unbanUser: "Débannir l'Utilisateur",
  removeApprover: "Retirer l'Approbateur",
  failedToApproveMatch: "Échec de l'approbation du match",
  failedToCompleteMatch: "Échec de la finalisation du match",
  startsIn: "Commence dans",

  // ========== TEMPS ET DATES ==========
  now: "maintenant",
  today: "aujourd'hui",
  yesterday: "hier",
  timeUntilAutoCancel: "min avant annulation auto",
  timeRemaining: "min restantes",

  // ========== NOTIFICATIONS ==========
  tournamentCreated: "Tournoi créé avec succès !",
  joinedTournament: "Tournoi rejoint avec succès !",
  leftTournament: "Tournoi quitté avec succès !",
  profileUpdated: "Profil mis à jour avec succès !",
  passwordChanged: "Mot de passe changé avec succès !",
  connectionRestored: "Connexion au serveur rétablie",
  reconnecting: "Reconnexion au serveur...",
  tournamentApproved: "Tournoi approuvé par",
  tournamentCompleted: "Tournoi terminé par",
  tournamentCancelled: "Tournoi annulé par",
  tournamentAutoCancelled: "Tournoi auto-annulé : {tournamentName}",
  createdGiveawayTournament: "a créé un tournoi CADEAU dans le lobby !",
  createdNewMatch: "a créé un nouveau match dans le lobby !",
  isNowOnline: "est maintenant en ligne !",
  commissionDistributed: "Commission distribuée !",
  commissionUpdated: "Paramètres de commission mis à jour !",

  // ========== CHAÎNES SUPPLÉMENTAIRES ==========
  participants: "Participants",
  insufficientPointsDetailed: "Points insuffisants ! Vous avez besoin de {needed} points mais n'avez que {current} points.",
  giveawayExplanation: "Dans les tournois cadeaux, vous payez {prize} points (prix) + {commission} points (commission) = {total} total",
  disobeyingWeaponRules: "⚠️ Ne pas respecter les règles d'armes entraînera une perte instantanée de points !",
  estimatedPrizePoolCalculation: "Cagnotte Estimée",
  baseCommission: "🏛️ Commission de Base",
  highKillBonus: "⚡ Bonus Haut Kill",
  totalCommission: "📊 Commission Totale",
  extraCommissionFromHighKills: "Commission supplémentaire de {rate}% pour nombre élevé de kills va à l'approbateur.",
  failedToLoadTournaments: "Échec du chargement des tournois",
  system: "Système",

  // ========== SPÉCIFIQUE CARTE TOURNOI ==========
  participantsCount: "{current}/{max}",
  prizeFormat: "🏆{amount}",
  entryFormat: "💰{amount}",
  killsFormat: "💀{amount}K",
  modeFormat: "⚔️{mode}",
  mapFormat: "📍{map}",
  teamFormat: "👥{count}",
  timeFormat: "⏰{time}",
  dateFormat: "📅{date}",

  // ========== AVERTISSEMENTS TEMPS D'ATTENTE ==========
  warningAutoCancel: "⚠️ {time}min avant annulation auto",
  warningTimeRemaining: "⏰ {time}min restantes",

  // ========== MATCH ACTIF ==========
  gameSettings: "Paramètres du Jeu",
  prizePool: "Cagnotte",

  // ========== TOURNOIS TERMINÉS ==========
  autoCancel: "AUTO-ANNULÉ",
  canceled: "ANNULÉ",
  cancelledBy: "Annulé par",
  more: "plus",
  approvedBy: "Approuvé par",

  // ========== CORRECTIONS TOURNOI ==========
  failedToCreateTournament: "Échec de la création du tournoi",
  matchType: "Type de Match",

  // ========== VOTE DÉMARRAGE ANTICIPÉ ==========
  voteToStart: "Voter pour Démarrer",
  earlyStartVoting: "Vote de Démarrage Anticipé",
  voteForEarlyStart: "Voter pour Démarrage Anticipé",
  removeVote: "Retirer le Vote",
  votesNeeded: "Votes Nécessaires",
  allPlayersVoted: "Tous les joueurs ont voté !",
  waitingForVotes: "En attente des votes...",
  prizeWillChange: "⚠️ La cagnotte changera car le lobby n'est pas plein",
  currentPrize: "Cagnotte Actuelle",
  newPrize: "Nouvelle Cagnotte",
  youVoted: "✓ Voté",
  voteRegistered: "Votre vote a été enregistré !",
  voteRemoved: "Votre vote a été retiré",
  failedToVote: "Échec de l'enregistrement du vote",

  // ========== CONTRÔLES CADEAU ==========
  instantStart: "Démarrage Instantané",
  requestVote: "Demander un Vote",
  giveawayCreatorControls: "Contrôles du Créateur Cadeau",
  startInstantly: "Démarrer Instantanément",
  initiateVote: "Initier un Vote",

  // ========== TOURNOI MULTI-ÉTAPES ==========
  multistepTournaments: "Tournois Multi-Étapes",
  multistepTournament: "Tournoi Multi-Étapes",
  createBracketTournament: "Créer un Tournoi Multi-Étapes",
  createBracket: "Créer",
  noBracketTournaments: "Pas encore de tournois multi-étapes",
  bracketTournamentCreated: "Tournoi multi-étapes créé !",
  numberOfTeams: "Nombre d'Équipes",
  costSummary: "Résumé des Coûts",
  prizePerWinner: "Prix par Gagnant",
  confirmCreate: "Confirmer la Création du Tournoi",
  viewBracket: "Tableau",
  tournamentBracket: "Tableau du Tournoi",
  joinedTeam: "Rejoint l'équipe avec succès !",
  tournamentStarted: "Le tournoi a commencé !",
  confirmWinner: "Définir cette équipe comme gagnante ?",
  yourTeam: "Votre Équipe",
  registration: "INSCRIPTION",
  final: "Finale",
  semiFinals: "Demi-Finales",
  quarterFinals: "Quarts de Finale",
  round: "Tour",
  matches: "matchs",
  tbd: "À déterminer",
  clickToSelectWinner: "Cliquez sur l'équipe pour sélectionner le gagnant",
  perWinner: "Par Gagnant",
  tournamentWinners: "Gagnants du Tournoi",
  full: "COMPLET",
  showTeams: "Afficher les Équipes",
  hideTeams: "Masquer les Équipes",
  startTournament: "Démarrer",
  viewAllTeams: "Toutes les Équipes et Matchs",
  allTeamsMatchups: "Toutes les Équipes et Matchs",
  teams: "Équipes",
  activeBracketMatches: "Matchs de Bracket Actifs",
  configureMatch: "Configurer le Match",
  configureMatchups: "Configurer les Matchs",
  startMatch: "Démarrer le Match",
  applications: "Candidatures",
  pendingTeams: "Équipes en Attente",
  approvedTeams: "Équipes Approuvées",
  pendingApplications: "Candidatures en Attente",
  noApplications: "Aucune candidature en attente",
  noApprovedTeamsYet: "Pas encore d'équipes approuvées",
  pendingTeamsApproval: "Équipes en Attente d'Approbation",
  pendingTeamsInfo: "Ces équipes attendent l'approbation",
  approveTeam: "Approuver",
  rejectTeam: "Rejeter",
  teamApproved: "Équipe approuvée !",
  teamRejected: "Équipe rejetée et supprimée",
  applicationApproved: "Candidature approuvée !",
  applicationRejected: "Candidature rejetée",
  errorApprovingTeam: "Erreur lors de l'approbation de l'équipe",
  errorRejectingTeam: "Erreur lors du rejet de l'équipe",
  errorApproving: "Erreur lors de l'approbation",
  errorRejecting: "Erreur lors du rejet",
  applyToTournament: "Postuler au Tournoi",
  applyToJoin: "Postuler pour Rejoindre",
  applyToTeam: "Postuler",
  applying: "Candidature en cours...",
  applied: "Postulé",
  teamApplied: "Candidature d'équipe soumise ! En attente d'approbation admin.",
  applicationSubmitted: "Candidature soumise ! En attente d'approbation admin.",
  applicationPending: "Votre candidature pour",
  isPending: "est en attente d'approbation",
  awaitingApproval: "En Attente d'Approbation",
  createNewTeam: "Créer une Nouvelle Équipe",
  youAreCaptain: "Vous êtes le Capitaine de l'Équipe !",
  captainInfo: "En tant que capitaine, vous pouvez définir les préférences pour qui peut rejoindre votre équipe.",
  teamPreferences: "Préférences de l'Équipe",
  setPreferencesFirst: "Sélectionnez d'abord une équipe",
  captain: "Capitaine",
  teamName: "Nom de l'Équipe",
  enterTeamName: "Entrez le nom de l'équipe",
  teammates: "Coéquipiers",
  teammate: "Coéquipier",
  teammatesHint: "Entrez les noms d'utilisateur de vos 4 coéquipiers",
  teammatesUpdated: "Noms des coéquipiers mis à jour !",
  editTeammates: "Modifier les noms des coéquipiers",
  editTeammateNames: "Modifier les Noms des Coéquipiers",
  editNames: "Modifier les Noms",
  editHint: "Mettez à jour les noms d'utilisateur de vos coéquipiers",
  saveChanges: "Sauvegarder les Modifications",
  saving: "Sauvegarde...",
  need4Teammates: "Vous devez spécifier les 4 coéquipiers",
  needMoreTeammates: "Vous avez besoin de plus de noms de coéquipiers",
  duplicateNames: "Les noms des coéquipiers doivent être uniques",
  dontIncludeYourself: "Ne vous incluez pas dans la liste des coéquipiers",
  errorCreatingTeam: "Erreur lors de la création de l'équipe",
  yourAllowedSquadmates: "Vos Coéquipiers Autorisés",
  noSquadmatesSet: "Aucun coéquipier défini - n'importe qui peut rejoindre votre équipe",
  edit: "Modifier",
  save: "Enregistrer",
  saving: "Enregistrement...",
  errorUpdating: "Erreur lors de la mise à jour des coéquipiers",
  joinThisTeam: "Rejoindre l'Équipe",
  joinYourTeam: "Rejoindre Votre Équipe",
  leaveTeam: "Quitter l'Équipe",
  confirmLeave: "Êtes-vous sûr de vouloir partir ?",
  errorJoining: "Erreur lors de l'adhésion à l'équipe",
  errorLeaving: "Erreur lors du départ",
  kickPlayer: "Retirer le joueur",
  kickTeam: "Expulser/Disqualifier l'Équipe",
  playerKicked: "Joueur retiré de l'équipe",
  teamKicked: "L'équipe a été expulsée",
  confirmKick: "Retirer ce joueur de votre équipe ?",
  enterKickReason: "Entrez la raison de l'expulsion/disqualification de cette équipe :",
  errorKicking: "Erreur lors du retrait du joueur",
  errorKickingTeam: "Erreur lors de l'expulsion de l'équipe",
  invited: "Invités",
  inviteOnly: "Sur Invitation Uniquement",
  yourNameInvited: "Votre nom doit être dans la liste des invités pour rejoindre",
  waiting: "en attente",
  waitingToJoin: "en attente de rejoindre",
  captain: "Capitaine",
  totalSlots: "Places Totales",
  alreadyJoined: "Déjà Rejoint",
  allTeamsTaken: "Toutes les Équipes Prises",
  teamsReady: "équipes prêtes",
  teamsWaitingForYou: "Équipes qui vous attendent",
  applyHint: "Postulez pour rejoindre une équipe existante ou créez la vôtre",
  applyHintAdmin: "Créez des équipes et configurez les matchs",
  createHintFull: "Toutes les places d'équipe sont remplies",
  enterRoomId: "Entrez l'ID de salle",
  customMap: "Carte Personnalisée",
  enterCustomMapName: "Entrez le nom de la carte personnalisée",
  matchStarted: "Le match a commencé !",
  errorStartingMatch: "Erreur lors du démarrage du match",
  confirmStart: "Démarrer le tournoi ? Les équipes seront verrouillées.",
  errorStarting: "Erreur lors du démarrage du tournoi",
  selectWinner: "Sélectionner le Gagnant",
  errorSettingWinner: "Erreur lors de la définition du gagnant",
  cancelReason: "Raison de l'annulation :",
  errorCancelling: "Erreur lors de l'annulation",
  firstRoundMatchups: "Matchs du Premier Tour",
  matchupHint: "Configurez quelles équipes s'affrontent",
  saveMatchups: "Sauvegarder les Matchs",
  selectBothTeams: "Veuillez sélectionner les deux équipes pour tous les matchs",
  duplicateTeam: "Chaque équipe ne peut être utilisée qu'une fois",
  matchupsConfigured: "Matchs configurés avec succès !",
  errorConfiguringMatchups: "Erreur lors de la configuration des matchs",
  adjustSizeTo: "Ajuster à",
  confirmAdjustSize: "Ajuster la taille du tableau ? Cela régénérera la structure.",
  bracketAdjusted: "Tableau ajusté",
  errorAdjustingSize: "Erreur lors de l'ajustement de la taille du tableau",
  allTeamsApproved: "Toutes les équipes approuvées",
  approveAllTeams: "Approuver Toutes les Équipes",
  confirmApproveAll: "Approuver toutes les équipes en attente ?",
  reroll: "Relancer",
  rerollMatchup: "Échange aléatoire",
  other: "Autre",
  otherMatchup: "Sélectionner l'équipe à échanger",
  selectTeamToSwap: "Sélectionnez l'équipe à échanger :",
  teamSwapped: "Équipe échangée !",
  errorSwappingTeam: "Erreur lors de l'échange d'équipe",
  or: "ou",
  fillAllFields: "Veuillez remplir tous les champs",
  required: "Requis",
  prizeSummary: "Résumé des Prix",
  freeForAdmins: "Gratuit pour les admins",
  gameModePerMatch: "Le mode de jeu et la carte sont configurés pour chaque match individuellement",
  each: "chacun",
  starting: "Démarrage...",
  pendingApproval: "en attente",

  // ========== VOTE TO START EARLY ==========
  voteEarlyStart: "Voter pour Démarrage Anticipé",
  voteToStart: "Voter pour Démarrage Anticipé",
  voteToStartEarly: "Voter pour démarrer le tournoi plus tôt",
  voteRecorded: "Vote enregistré ! ({current}/{total})",
  voteRemoved: "Vote retiré",
  voteRequestSent: "Demande de vote envoyée à tous les participants !",
  voteInProgress: "Vote en cours ({current}/{total})",
  vote: "VOTER",
  earlyPrize: "Démarrage Anticipé",
  votesNeeded: "votes nécessaires",
  votedPlayers: "Joueurs ayant voté",
  voteRequestSentWaiting: "Demande de vote envoyée ! En attente des joueurs...",
  voteNote: "Le tournoi démarrera automatiquement quand tous les vrais joueurs auront voté.",
  voteNoteGiveaway: "Pour les cadeaux, le créateur doit manuellement démarrer le match après réception de tous les votes.",

  // ========== CREATE TOURNAMENT TEAM PREFERENCE ==========
  teamPreference: "Préférence d'Équipe",
  randomAnyPlayerCanJoin: "Aléatoire - N'importe quel joueur peut rejoindre votre équipe",
  specificChooseTeammates: "Spécifique - Choisir votre/vos coéquipier(s)",
  emptySlotOptional: "Emplacement Vide (Optionnel)",
  enterPlayerInGameName: "Entrer le nom en jeu du joueur",

  // ========== BR EDIT TEAM ==========
  editTeam: "Modifier l'Équipe",
  viewTeam: "Voir l'Équipe",
  viewPlayers: "Voir les Joueurs",
  viewTeamPositions: "Positions des Équipes",
  editAllowedTeammates: "Modifier les Coéquipiers Autorisés",
  teammatesHint: "Entrez les noms des joueurs autorisés à rejoindre votre équipe. Laissez vide ou définissez sur aléatoire pour autoriser tout le monde.",
  mpTeammatesHint: "Entrez les noms des joueurs pour autoriser des joueurs spécifiques. Utilisez 🎲 pour les joueurs aléatoires. Les places vides sont verrouillées.",
  specificPreference: "Mode Spécifique - Seuls les joueurs nommés peuvent rejoindre",
  captain: "Capitaine",
  specific: "SPÉCIFIQUE",
  lockedSlot: "Place Verrouillée",
  lockedSlotInfo: "🔒 Verrouillé - personne ne peut rejoindre",
  openSlot: "Place Ouverte",
  waitingFor: "En attente de",
  unlockSlot: "Déverrouiller la place (autoriser aléatoire)",
  lockSlot: "Verrouiller la place",

  // ========== KICK PLAYER MODAL ==========
  kickPlayerTitle: "Retirer le Joueur",
  kickPlayerConfirm: "Êtes-vous sûr de vouloir retirer ce joueur ?",
  kickFillerConfirm: "Retirer ce remplisseur du tournoi ?",
  removeFromTournament: "Retirer du Tournoi",
  kickReason: "Raison (optionnel)",

  // ========== MP TEAM SELECTION ==========
  teamSelection: "Sélection d'Équipe",
  selectTeam: "Sélectionner votre Équipe",
  mpTeamSelectInfo: "Choisissez quelle équipe rejoindre pour ce match",
  youWillBeCaptain: "Vous serez le capitaine de l'équipe",
  youAreInvited: "Vous êtes invité dans cette équipe",
  joiningViaRandomSlot: "Rejoindre via un emplacement aléatoire",
  teamNotAccepting: "Cette équipe n'accepte pas de joueurs",
  squadOnly: "Escouade uniquement",
  spotsAvailable: "places disponibles",
  captainSettings: "Paramètres du Capitaine",
  captainSettingsInfo: "En tant que capitaine, choisissez qui peut rejoindre votre équipe",
  teamJoinMode: "Mode de Rejoindre l'Équipe",
  randomTeammate: "🎲 Aléatoire - N'importe quel joueur peut rejoindre votre équipe",
  specificTeammate: "👥 Spécifique - Choisir votre/vos coéquipier(s)",
  slot: "Emplacement",
  clickToEmpty: "Cliquer pour laisser vide",
  clickForRandom: "Cliquer pour aléatoire",
  random: "Aléatoire",
  setRandom: "Définir Aléatoire",
  anyPlayerCanJoin: "N'importe quel joueur peut rejoindre cet emplacement",
  teammatesNote: "Laissez des emplacements vides pour empêcher d'autres de rejoindre votre équipe",
  joining: "Rejoindre...",
  createTeam: "Créer l'Équipe",
  joinTeam: "Rejoindre l'Équipe",
  editTeamPreferences: "Modifier les Préférences d'Équipe",
  viewAllTeamPositions: "Voir Toutes les Positions d'Équipe",
  emptySlot: "Emplacement Vide",
  enterPlayerInGameName: "Entrer le nom en jeu du joueur",
  enterNameOrSetRandom: "Entrer le nom ou définir aléatoire",
  enterExactInGameName: "Entrez le nom en jeu exact de votre coéquipier, ou définissez aléatoire",
  editAllowedSquadmates: "Modifier les Coéquipiers Autorisés",
  squadPreference: "Mode Escouade - Coéquipiers spécifiques uniquement",
  randomPreference: "Mode Aléatoire - N'importe qui peut rejoindre",
  squadmatesHint: "Entrez les noms des joueurs autorisés à rejoindre votre équipe. Laissez vide ou définissez aléatoire pour autoriser tout le monde.",
  slot: "Emplacement",
  anyoneCanJoin: "N'importe qui peut rejoindre cet emplacement",
  emptySlotInfo: "Vide - personne ne peut utiliser cet emplacement",
  specificPlayer: "Seul ce joueur peut rejoindre",
  clearSlot: "Vider l'Emplacement",
  randomPlayer: "Joueur Aléatoire",
  enterPlayerName: "Entrer le nom du joueur...",
  playerName: "Nom du Joueur",
  saveChanges: "Sauvegarder les Modifications",
  saving: "Sauvegarde...",

  // ========== VOTE EARLY START MODAL ==========
  prizeReductionWarning: "Avertissement de Réduction de Prix",
  lobbyNotFull: "Le lobby n'est pas plein ({current}/{max} joueurs)",
  current: "Actuel",

  // ========== KICK PLAYER MODAL EXTRAS ==========
  kick: "Expulser",
  realPlayer: "Vrai Joueur",
  fillerPlayer: "Joueur Remplisseur",
  fillerBot: "Bot Remplisseur",
  playerWillReceiveRefund: "Le joueur recevra un remboursement de {amount} points",
  thisActionIsPermanent: "Cette action est permanente",
  playerWillBeRemoved: "Ce joueur sera retiré du tournoi et ne pourra pas rejoindre.",
  tournamentInformation: "Information du Tournoi",
  currentPlayers: "Actuel: {current}/{max} joueurs",
  kickParticipant: "Expulser {type}",
  player: "Joueur",
  filler: "Remplisseur",
  yourFiller: "Votre Remplisseur",
  youAddedThis: "Vous avez ajouté ce remplisseur",
  othersFiller: "Remplisseur de quelqu'un d'autre",
  addedBySomeoneElse: "Ajouté par un autre joueur",
  refundInformation: "Information de Remboursement",
  playerRefund: "Le joueur recevra un remboursement de {amount} points",
  fillerRefund: "Le propriétaire du remplisseur recevra un remboursement de {amount} points",
  fillerRefundNote: "Le remboursement va à la personne qui a ajouté le remplisseur",
  permanentAction: "Cette action est permanente",
  playerKickWarning: "Ce joueur sera retiré du tournoi et ne pourra pas rejoindre.",
  fillerKickWarning: "Ce remplisseur sera retiré du tournoi et ne peut pas être rajouté.",
  tournamentInfo: "Information du Tournoi",
  currentParticipants: "Actuel: {current}/{max} joueurs",
  currentFillers: "Remplisseurs: {count}",
  kicking: "Expulsion...",
  confirmKick: "Expulser {type}",
  // Subscription translations
  
  
  // ========== MP MULTISTEP & ADDITIONAL ==========
  mpMultistep: "MP Multi-étapes",
  mpMultistepDesc: "Tournoi multijoueur par équipes avec progression en bracket. 5 joueurs par équipe.",
  teamsCount: "4, 8 ou 16 équipes",
  bracketElimination: "Format élimination directe",
  gameModePerMatch: "Mode de jeu défini par match",
  soloSquadModes: "Modes Solo, Duo ou Escouade",
  roundsRange: "2-5 manches",
  cumulativePoints: "Points cumulés des éliminations + placement",
  pts: "pts",
// ========== BR MULTISTEP TOURNAMENT ==========
  brMultistep: "BR Multi-étapes",
  brMultistepDesc: "Tournoi Battle Royale avec plusieurs manches",
  br_multistep: "BR Multi-étapes",
  createBRMultistep: "Créer un tournoi BR Multi-étapes",
  brMultistepCreated: "Tournoi BR Multi-étapes créé avec succès",
  solo: "Solo",
  soloDesc: "Joueurs individuels en compétition",
  duo: "Duo",
  duoDesc: "Équipes de 2 joueurs",
  squad: "Escouade",
  squadDesc: "Équipes de 4 joueurs",
  controlMode: "Mode de contrôle",
  control: "Contrôle",
  manual: "Manuel",
  manualDesc: "Admin gère les salles manuellement",
  bot: "Bot",
  botDesc: "Bot crée et gère les salles automatiquement",
  botIdle: "Bot inactif",
  botCreatingRoom: "Création de la salle...",
  botRoomReady: "Salle prête",
  botWaitingPlayers: "En attente des joueurs",
  botMatchActive: "Match en cours",
  botExtractingResults: "Extraction des résultats",
  botRoundComplete: "Manche terminée",
  botError: "Erreur du bot",
  botReconnected: "Bot reconnecté",
  numberOfRounds: "Nombre de manches",
  rounds: "Manches",
  scheduledStart: "Début prévu",
  scheduledStartHint: "Quand le tournoi doit commencer",
  pointsConfiguration: "Configuration des points",
  pointsPerKill: "Points par élimination",
  perKill: "par élimination",
  placementPoints: "Points de placement",
  placementHint: "Points attribués selon le classement final",
  addPlacement: "Ajouter placement",
  place: "Place",
  pointsDistribution: "Distribution des points",
  teams: "Équipes",
  allTeams: "Toutes les équipes",
  noTeamsYet: "Pas encore d équipes",
  createNewTeam: "Créer une nouvelle équipe",
  teamName: "Nom d équipe",
  enterTeamName: "Entrez le nom d équipe",
  teammates: "Coéquipiers",
  teammate: "Coéquipier",
  enterTeammateNames: "Entrez les noms des coéquipiers",
  enterAllTeammates: "Entrez tous les noms des coéquipiers",
  teamSize: "Taille d équipe",
  teamWillHave: "L équipe aura",
  youPlus: "Vous +",
  editTeam: "Modifier l équipe",
  editTeammatesHint: "Modifier vos coéquipiers",
  editTeamNote: "Vous pouvez modifier votre équipe avant le début du tournoi",
  teamUpdated: "Équipe mise à jour avec succès",
  viewTeams: "Voir les équipes",
  yourTeam: "Votre équipe",
  leader: "Leader",
  joinThisTeam: "Rejoindre cette équipe",
  joinMyTeam: "Rejoindre mon équipe",
  joinMyTeamSelect: "Sélectionnez une équipe à rejoindre",
  joinWithTeam: "Rejoindre avec équipe",
  selectYourTeam: "Sélectionnez votre équipe",
  joinedTeam: "Équipe rejointe avec succès",
  leaveTeam: "Quitter l équipe",
  duplicateTeammate: "Nom de coéquipier en double",
  multipleTeamsInvited: "Plusieurs équipes peuvent être invitées",
  pendingSlots: "Places disponibles",
  manageRounds: "Gérer les manches",
  matchSettings: "Paramètres du match",
  editSettings: "Modifier les paramètres",
  saveSettings: "Enregistrer les paramètres",
  saveChanges: "Enregistrer les modifications",
  settingsSaved: "Paramètres enregistrés avec succès",
  confirmCreate: "Créer le tournoi?",
  confirmStart: "Démarrer le tournoi?",
  confirmCancel: "Annuler le tournoi?",
  confirmSwitchToManual: "Passer en contrôle manuel?",
  switchedToManual: "Passé en contrôle manuel",
  roundStarting: "Manche en cours de démarrage",
  lobby: "Lobby",
  inProgress: "En cours",
  completed: "Terminé",
  cancelled: "Annulé",
  startsAt: "Commence à",
  joining: "Connexion...",
  creating: "Création...",
  saving: "Enregistrement...",
  joinTournament: "Rejoindre le tournoi",
  joinedTournament: "Tournoi rejoint",
  leftTournament: "Tournoi quitté",
  tournamentStarted: "Le tournoi a commencé",
  tournamentCancelled: "Le tournoi a été annulé",
  tournamentSummary: "Résumé du tournoi",
  errorCreating: "Erreur lors de la création du tournoi",
  failedToJoin: "Échec de la participation au tournoi",
  failedToJoinTeam: "Échec de la participation à l équipe",
  failedToLeave: "Échec de la sortie",
  failedToStart: "Échec du démarrage",
  failedToStartRound: "Échec du démarrage de la manche",
  failedToCancel: "Échec de l annulation",
  failedToSaveSettings: "Échec de l enregistrement des paramètres",
  failedToUpdateTeam: "Échec de la mise à jour de l équipe",
  switchFailed: "Échec du changement",
  commandFailed: "Commande échouée",
  reconnectFailed: "Échec de la reconnexion",
  commandSent: "Commande envoyée",
  maxPlayers: "Joueurs max",
  leaveEmptyForPublic: "Laisser vide pour public",
  optional: "Optionnel",
  required: "Requis",
  freeForAdmins: "Gratuit pour les admins",
  minPlayersRequired: "Nombre minimum de joueurs requis",
  playersNotDivisible: "Nombre de joueurs non divisible par la taille de l équipe",
  selectTournamentType: "Sélectionner le type de tournoi",

  weeklyPointDeals: "Offres de Points Hebdomadaires",
  subscriptionDescription: "50% de points instantanément + 50% quotidiennement pendant 7 jours",
  activePlan: "Actif",
  dayProgress: "Jour",
  pointsReceived: "points reçus",
  alreadyActive: "Déjà actif",
  selectPlan: "Choisir le plan",
  totalPoints: "POINTS TOTAUX",
  instant: "instantané",
  perDay: "/jour",
  days: "jours",
  ptsPerDollar: "pts par $1",
  perWeek: "/semaine",
  processingSubscription: "Traitement de votre abonnement...",
  tierBasic: "Basique",
  tierStandard: "Standard",
  tierPlus: "Plus",
  tierPremium: "Premium",
  tierMax: "Max",
};

export default frenchTranslations;
